import "react-tabs/style/react-tabs.css";
import "../../styles/atomic.scss";
import "../../styles/splash.scss";
import { Link } from "react-router-dom";
import SplashHeader from "./SplashHeader";
// import TerminalAndPages from "./TerminalAndPages";
// import WebsiteGameContainer from "../WebsiteGame/WebsiteGameContainer";
import ItchShowcase from "./ItchShowcase";

function SitePages() {
  const pages = [
    { name: "Movie Night", path: "/movie-night", description: "Watch history" },
    { name: "Quotes & Lyrics", path: "/quotes", description: "Stuff I like" },
  ];

  return (
    <div id="site-pages" className="bgc-ddd">
      <h3>Pages</h3>
      <div className="pages-grid">
        {pages.map((page, i) => (
          <Link key={i} to={page.path} className="page-link">
            <h4>{page.name}</h4>
            <p>{page.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}

function Splash() {
  return (
    <div id="splash">
      <SplashHeader />
      <SitePages />
      <ItchShowcase />
    </div>
  );
}

export default Splash;
